import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export abstract class DewBaseCmpDirective implements OnDestroy {
  protected destroyed$: Subject<void> = new Subject();

  protected constructor() {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
